import { DISPENSE_ATTEMPTS_TAB } from 'models/dispense-attempts/constants';

export const DISPENSE_ATTEMPTS_TABS_ARRAY = Array.from(Object.values(DISPENSE_ATTEMPTS_TAB));

